import { useContext, Context } from 'react';
import { AnonymousViewModel } from '@steelbuy/ts-shared';

import { SearchDataProviderValue } from '../provider/SearchDataProviderValue';

export const useSearchData = <Model extends AnonymousViewModel>(
    v: Context<SearchDataProviderValue<Model>>
): SearchDataProviderValue<Model> => useContext(v);
